// extracted by mini-css-extract-plugin
module.exports =  {"info":"da51a739f7--info--JAvte","data":"da51a739f7--data--Nd83q","logo":"da51a739f7--logo--my1AX"};